import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import FairProductCard from '../../../Fair/components/FairProductCard/FairProductCard';
import { getWeeksFromData } from '../../../Fair/getColumns';
import Spinner from '../../../../Utils/Spinner';

class FairCart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeWeekDate: null,
        };
    }

    componentWillUnmount() {
        if (this.weekBlurTimeout) {
            clearTimeout(this.weekBlurTimeout);
        }
    }

    handleWeekFocus = (weekDate) => {
        if (this.weekBlurTimeout) {
            clearTimeout(this.weekBlurTimeout);
            this.weekBlurTimeout = null;
        }
        this.setState({ activeWeekDate: weekDate });
    };

    handleWeekBlur = () => {
        this.weekBlurTimeout = setTimeout(() => {
            this.setState({ activeWeekDate: null });
            this.weekBlurTimeout = null;
        }, 0);
    };

    handleSetFairProducts = () => {
        // FairWeekInput mutates product amounts in place; force a re-render.
        this.props.setFairProducts([...(this.props.fairProducts || [])]);
    };

    render() {
        const {
            loading,
            fairProducts,
            addProduct,
            loadingState,
            intl,
        } = this.props;
        const { activeWeekDate } = this.state;
        const weeks = getWeeksFromData(fairProducts);
        const abbreviation = intl.formatMessage({
            id: 'fair.week_abbreviation',
        });
        const pageSize = Math.max((fairProducts || []).length, 1);

        return (
            <div className="fair-page fair-cart-list">
                <div className="cart__header">
                    <span className="cart__order-date">
                        <FormattedMessage id="cart.fair.title" />
                    </span>
                </div>

                <div className="fair-products-list">
                    {weeks.length > 0 && (
                        <div className="fair-products-list__weeks-header">
                            <div className="fair-products-list__weeks-header-main">
                                <div className="fair-products-list__weeks-header-content">
                                    <div
                                        className="fair-products-list__weeks-header-grid"
                                        style={{
                                            gridTemplateColumns: `repeat(${Math.max(
                                                weeks.length,
                                                1
                                            )}, minmax(40px, 1fr))`,
                                        }}
                                    >
                                        {weeks.map((week) => {
                                            const weekNumber = String(
                                                week.week_name
                                            ).replace(/\D/g, '');
                                            const isActive =
                                                activeWeekDate ===
                                                week.week_date;

                                            return (
                                                <span
                                                    key={week.week_date}
                                                    className={`fair-products-list__week-tab ${
                                                        isActive
                                                            ? 'fair-products-list__week-tab--active'
                                                            : ''
                                                    }`}
                                                >
                                                    {abbreviation}
                                                    {weekNumber}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="fair-products-list__weeks-header-action fair-products-list__weeks-header-action--spacer"
                                aria-hidden="true"
                            />
                        </div>
                    )}

                    <div className="fair-products-list__items">
                        {loading && (
                            <div className="fair-products-list__loading">
                                <Spinner
                                    width={40}
                                    height={40}
                                    className="brand-color"
                                />
                            </div>
                        )}
                        {!loading &&
                            (!fairProducts || fairProducts.length === 0) && (
                                <div className="fair-products-list__empty">
                                    <FormattedMessage id="table.no_data_text" />
                                </div>
                            )}
                        {!loading &&
                            fairProducts &&
                            fairProducts.map((productItem, index) => (
                                <FairProductCard
                                    key={
                                        productItem.product
                                            ? productItem.product.id
                                            : index
                                    }
                                    productItem={productItem}
                                    index={index}
                                    weeks={weeks}
                                    showProductPhoto={false}
                                    addProduct={addProduct}
                                    setFairProducts={this.handleSetFairProducts}
                                    loadingState={loadingState}
                                    pageSize={pageSize}
                                    onWeekFocus={this.handleWeekFocus}
                                    onWeekBlur={this.handleWeekBlur}
                                />
                            ))}
                    </div>
                </div>
            </div>
        );
    }
}

FairCart.propTypes = {
    loading: PropTypes.bool,
    fairProducts: PropTypes.array,
    addProduct: PropTypes.func,
    setFairProducts: PropTypes.func,
    loadingState: PropTypes.object,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(FairCart);
